import Api from "../../../config/api";
import {
  CREATE_TAX,
  SEARCH_TAX,
  SEARCH_TAX_BY_ID,
  UPDATE_TAX,
} from "../../../utils/constants";
import { showToast } from "../../toast/ShowToast";

export const getTax = async (params?: any) => {
  try {
    const res = await Api(false).get(SEARCH_TAX, { params });
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const getTaxById = async (id?: string) => {
  try {
    const res = await Api(false).get(`${SEARCH_TAX_BY_ID}/${id}`);
    return res;
  } catch (error: any) {
    if (error?.response?.status >= 400 && error?.response?.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
    } else {
      showToast(`${error?.response?.data?.message}`, "error");
    }
  }
};

export const createTax = async (body: any, hideLoader: () => void) => {
  try {
    const res = await Api(false).post(CREATE_TAX, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};

export const updateTax = async (
  body: any,
  id: string,
  hideLoader: () => void
) => {
  try {
    const res = await Api(false).put(`${UPDATE_TAX}/${id}`, body);
    return res;
  } catch (error: any) {
    if (error.response.status >= 400 && error.response.status <= 499) {
      showToast(`${error.response.statusText}`, "error");
      hideLoader();
    } else {
      showToast(`${error.response.data.message}`, "error");
      hideLoader();
    }
  }
};
